export default {
  /**
   * 当前域名
   */
  baseHost: '//www.infoq.cn/',
  /**
   * 用户相关所用域名
   */
  accountHost: '//account.infoq.cn/',
  /**
   * 广告相关所用域名
   */
  adHost: '//a.geekbang.org/',
  /**
   * 账户中心的接口所用域名
   */
  account: '//account.geekbang.org/'
}
